import { groupSectionEntityName } from '../../../../backend/config/classifiers/GroupSectionClassifier/shared';
import { ContactManagementConfigContext } from '../../../../ui/providers';
import { handleErrorSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useAnonymousClient } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';
export function useGroupSections() {
    const context = React.useContext(ContactManagementConfigContext);
    const anonymousClient = useAnonymousClient(context.appName, groupSectionEntityName);
    const [sections, setSections] = React.useState();
    React.useEffect(() => {
        anonymousClient
            .storageList({
            filter: [{ column: 'status', op: '=', value: 'active' }],
            orderBy: [{ column: 'displayOrder' }, { column: 'name' }],
        })
            .then((response) => setSections(response.rows))
            .catch((error) => {
            handleErrorSnackbar(error);
            setSections([]);
        });
    }, [anonymousClient]);
    return sections;
}
